'use client';

import Script from 'next/script';
import { initializeRedditPixel } from '~/services/analytics/providers/reddit';

export default function RedditScript() {
  return (
    <Script
      src="https://www.redditstatic.com/ads/pixel.js"
      strategy="afterInteractive"
      id="reddit-pixel"
      onLoad={initializeRedditPixel}
    />
  );
}
